"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiService = /** @class */ (function () {
    function ApiService() {
    }
    ApiService.cardImageUrl = function (character, cardName) {
        var characterString = character.toLowerCase().replace(/ /g, "_");
        var cardNameString = cardName.toLowerCase().replace(/ /g, "_").replace(/'/g, "");
        return process.env.PUBLIC_URL + "/static/images/cards/" + characterString + "/" + cardNameString + ".png";
    };
    ApiService.defaultCardUrl = function (characterType) {
        if (characterType === void 0) { characterType = "scoundrel"; }
        var characterString = characterType.toLowerCase().replace(/ /g, "_");
        return process.env.PUBLIC_URL + "/static/images/cards/" + characterString + "/" + characterString + "_back.png";
    };
    ApiService.characterIconUrl = function (characterType) {
        if (characterType === void 0) { characterType = "scoundrel"; }
        var characterString = characterType.toLowerCase().replace(/ /g, "_");
        return process.env.PUBLIC_URL + "/static/images/icons/" + characterString + ".svg";
    };
    return ApiService;
}());
exports.ApiService = ApiService;



//////////////////
// WEBPACK FOOTER
// ./src/services/ApiService.ts
// module id = 129
// module chunks = 0